import React, { FC } from 'react'

import { CardsGrid } from './CardsGrid'
import { Content } from 'sdk/components'
import { useWindowSize } from 'core/hooks/useWindowSize'

import classes from './style.module.scss'

interface ProductFeatureCardData {
  icon?: string
  text?: string
}

interface ProductFeatureDisplayProps {
  desktopBackgroundUrl: string
  mobileBackgroundUrl: string
  cards: ProductFeatureCardData[]
}

export const ProductFeatureDisplay: FC<ProductFeatureDisplayProps> = ({
  desktopBackgroundUrl,
  mobileBackgroundUrl,
  cards,
}) => {
  const { width } = useWindowSize()
  const isTablet = width <= 860

  return (
    <>
      <div
        className={classes.container}
        style={
          {
            '--desktop-bg': `url(${desktopBackgroundUrl})`,
            '--mobile-bg': `url(${mobileBackgroundUrl})`,
          } as React.CSSProperties
        }
      >
        {!isTablet ? (
          <div className={classes.content}>
            <CardsGrid cards={cards} />
          </div>
        ) : null}
      </div>
      {isTablet ? <CardsGrid cards={cards} /> : null}
    </>
  )
}
